module.exports = __webpack_public_path__ + "static/media/address-book.ef9d5736.svg";